import { Component } from '@angular/core';
import { encapsulation } from '../../encapsulation';

@Component({
    selector: 'ubx-accordion-body',
    templateUrl: './accordion-body.component.html',
    host: { class: 'ubx-accordion-body' },
    encapsulation
})
export class UBXAccordionBodyComponent { }
